var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('img',{attrs:{"src":'http://9game.laolongtang.com.cn/uploads/mark_picture/'+_vm.Id+'.jpg'}})])
}
var staticRenderFns = []

export { render, staticRenderFns }